function findFocusableEl (el) {
  const selector = 'input, select, button, textarea';
  return (el.matches(selector) && el) || el.querySelector(selector);
}

export const focus = {
  inserted: function (el, binding) {
    if (binding.value) findFocusableEl(el).focus();
    else findFocusableEl(el).blur();
  },

  componentUpdated: function (el, binding) {
    if (binding.modifiers.lazy) {
      if (Boolean(binding.value) === Boolean(binding.oldValue)) {
        return;
      }
    }

    if (binding.value) findFocusableEl(el).focus();
    else findFocusableEl(el).blur();
  },
};
